import React, { useState } from "react";
import styled from "styled-components";
import { fontSize, fontsWeight } from "../shared-constants/fonts";
import {
  downloadAsImage,
  downloadAsPdf,
} from "../shared-utils/downloadComponent";
import { icons } from "../shared-asstes/icons";
import { dimens } from "../shared-constants/dimens";
import { colors } from "../shared-constants/colors";
import CustomLoading from "./CustomLoading";

interface IProps {
  componentRef: any;
  title: string;
  fileName?: string;
  setNoneAfterDownload?: boolean
}

const Download = ({ componentRef, title, fileName, setNoneAfterDownload }: IProps) => {
  const [imageLoading, setImageLoading] = useState<boolean>(false);
  const [pdfLoading, setPdfLoading] = useState<boolean>(false);

  return (
    <>
      <Title>{title}</Title>
      <DownloadContainer>
        <li
          onClick={() =>
            downloadAsPdf({
              componentRef: componentRef,
              fileName: fileName,
              setLoading: setPdfLoading,
              setNoneAfterDownload: setNoneAfterDownload,
            })
          }
        >
          <img src={icons.DOCUMENT} />
          {pdfLoading ? (
            <LoadingContainer>
              <CustomLoading size="small" />
            </LoadingContainer>
          ) : (
            <span>دانلود فایل PDF</span>
          )}
        </li>
        <Line />
        <li
          onClick={() => {
            downloadAsImage({
              componentRef: componentRef,
              fileName: fileName,
              setLoading: setImageLoading,
              setNoneAfterDownload: setNoneAfterDownload,
            });
          }}
        >
          <img src={icons.IMAGE} />
          {imageLoading ? (
            <LoadingContainer>
              <CustomLoading size="small" />
            </LoadingContainer>
          ) : (
            <span>دانلود فایل عکس</span>
          )}
        </li>
      </DownloadContainer>
    </>
  );
};

export default Download;

const Title = styled.h5`
  font-size: ${fontSize.MEDIUM};
  margin-bottom: ${dimens.SPACING_XXS_NUDGE};
`;

const DownloadContainer = styled.ul`
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontsWeight.MEDIUM};
  li {
    display: flex;
    align-items: center;
    padding: ${dimens.SPACING_M} 0;
    cursor: pointer;
    img {
      margin-left: ${dimens.SPACING_XS};
    }
  }
`;

const Line = styled.div`
  border-top: 1px dashed ${colors.stroke2};
`;

const LoadingContainer = styled.div`
  div {
    justify-content: flex-start !important;
    margin-top: 0 !important;
  }
`;
